import { DataFilter } from '@siclop/kstone-vue'
import type { LeaveRequestStatus } from '../enums'

export class LeaveRequestFilter extends DataFilter {
  employeeId?: number
  leaveTypeId?: number
  status?: LeaveRequestStatus
  startDateFrom?: string
  startDateTo?: string
  reviewedByEmployeeId?: number

  constructor(data?: Partial<LeaveRequestFilter>) {
    super(data)
    if (data) {
      this.employeeId = data.employeeId
      this.leaveTypeId = data.leaveTypeId
      this.status = data.status
      this.startDateFrom = data.startDateFrom
      this.startDateTo = data.startDateTo
      this.reviewedByEmployeeId = data.reviewedByEmployeeId
    }
  }
}
